"use client";
// Imports
import { ComponentWrapper, Img } from "@/components";
import Link from "next/link";
import { useState, useEffect } from "react";
import { sendGTMEvent } from "@next/third-parties/google";
import { resolveLink } from "@/lib/utils";

// Horizontal Advertisement
export function HorizontalAdvertisement({ type, ads }) {
  // SSR + first paint always reserve ad space (null → mount was a CLS culprit).
  const [ad, setAd] = useState(() => ads?.[0] ?? null);

  useEffect(() => {
    if (!ads?.length) return;
    setAd(ads[Math.floor(Math.random() * ads.length)]);
  }, [ads]);

  if (!ad) return null;

  // if no leaderboard_desktop or leaderboard_mobile, return null
  if (ad?.leaderboard_desktop === null && ad?.leaderboard_mobile === null) {
    return null;
  }

  function triggerGTMEvent() {
    sendGTMEvent("event", "clickedAdvertisement", {
      value: ad.title,
    });
  }

  // Render — CSS breakpoints instead of useMediaQuery so desktop doesn't
  // flash the 320×50 mobile slot then jump to 728×90 after hydration.
  return (
    <ComponentWrapper type={type}>
      <div className="flex justify-center">
        <div className="flex w-[320px] max-w-full flex-col items-center md:w-[728px]">
          <Link
            target="_blank"
            data-ad={ad?.title}
            href={resolveLink(ad?.link) ?? "#"}
            onClick={triggerGTMEvent}
            className="relative block h-[50px] w-full md:h-[90px]"
          >
            {ad?.leaderboard_mobile && (
              <span className="absolute inset-0 md:hidden">
                <Img
                  data={ad.leaderboard_mobile}
                  fill
                  sizes="320px"
                  className="object-contain rounded-[3px]"
                />
              </span>
            )}
            {ad?.leaderboard_desktop && (
              <span className="absolute inset-0 hidden md:block">
                <Img
                  data={ad.leaderboard_desktop}
                  fill
                  sizes="728px"
                  className="object-contain rounded-[3px]"
                />
              </span>
            )}
          </Link>
          <p className="pt-3 font-body text-xs text-center text-brand-espresso/70">
            Advertisement
          </p>
        </div>
      </div>
    </ComponentWrapper>
  );
}
